import styled from 'styled-components'
import Link from '../../utils/Link'
import TitleWrapper from './StyledTitleWrapper'

export default styled(Link)`
  color: #333;
  font-size: 14px;
  
  &:hover {
    text-decoration: none;
  }
  
  &:hover ${TitleWrapper} {
    text-decoration: underline;
  }
`
